import { c as _c } from "react/compiler-runtime";
import { hasAnyScope, type AnyAuthProviderContext, hasAllScopes, type AuthProviderProps } from '@newfront-insurance/next-auth';
import { useProvider, type Provider } from '@newfront-insurance/react-provision';
export function useHasAnyScope(authProvider, scopes) {
  const $ = _c(5);
  const {
    userDetails: user
  } = useProvider(authProvider);
  if (!user) {
    return false;
  }
  let t0;
  if ($[0] !== user.scopes) {
    t0 = user.scopes ?? [];
    $[0] = user.scopes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== scopes || $[3] !== t0) {
    t1 = hasAnyScope(t0, scopes);
    $[2] = scopes;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
export function useHasAllScopes(authProvider, scopes) {
  const $ = _c(5);
  const {
    userDetails: user
  } = useProvider(authProvider);
  if (!user) {
    return false;
  }
  let t0;
  if ($[0] !== user.scopes) {
    t0 = user.scopes ?? [];
    $[0] = user.scopes;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== scopes || $[3] !== t0) {
    t1 = hasAllScopes(t0, scopes);
    $[2] = scopes;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}